module.exports = __webpack_public_path__ + "img/2.57f78b2.png";